import React from 'react';
import Tippy from '@tippy.js/react';
import { ApButtonSecondary } from '@alixpartners/ui-components';
import { Note, Wrapper } from './NavigationHeaderCopyLinkBlock.styles';
import { copyStringToBuffer } from '../../../utils/common';

export const NavigationHeaderCopyLinkBlock: React.FC = () => {
  const clientReportSiteLink: string = `${window.location.origin}/client-report-site`;
  return (
    <Wrapper>
      <Note>
        Note. Your clients need to be invited to be able to view the portal.
      </Note>

      <Tippy
        arrow={true}
        placement="bottom"
        animation="fade"
        boundary="window"
        trigger="click"
        content={'Copied'}
      >
        <ApButtonSecondary
          onClick={() => copyStringToBuffer(clientReportSiteLink)}
        >
          Copy Portal URL
        </ApButtonSecondary>
      </Tippy>
    </Wrapper>
  );
};
